var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"phenviron"},[_c('hpheader'),_c('div',{staticClass:"phvir-hea"},[_vm._v(_vm._s(_vm.info.around))]),_c('div',{staticClass:"phenviron-scrl"},_vm._l((_vm.companyarou),function(item,index){return _c('div',{key:index,staticClass:"phenvirscrl-item"},[_c('img',{attrs:{"src":item.images}})])}),0),_c('hpfooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }